import userFortuneCoin from './user-fortune-coin'

export default userFortuneCoin